import { isNotNil } from 'shared/src/utils';
import type { SimilarGoodsItem } from 'shared/src/api/goodsService/getSimilarGoods/types';

export const buildGoodsAnalyticsParams = (item: SimilarGoodsItem) => ({
  GOODS_SNO: item.sno,
  GOODS_NAME: item.name,
  MARKET_SNO: item.market.sno,
  MARKET_NAME: item.market.name,
  MARKET_TYPE: item.market.market_type.name,
  CATEGORY_SNO: item.category?.sno,
  CATEGORY_NAME: item.category?.name,
  STANDARD_CATEGORY_SNO: item.standard_category.sno,
  STANDARD_CATEGORY_NAME: item.standard_category.name,
  IS_NEW: item.is_new ? '1' : '0',
  IS_AD: isNotNil(item.ad) ? '1' : '0',
  DELIVERY_TYPE: item.delivery_type,
  DISCOUNT_RATE: item.discount_rate,
  SALES_PRICE: item.price,
  REVIEW_COUNT: item.total_review_count,
  REVIEW_RATING: item.positive_review_rate,
});
